module.exports = __webpack_public_path__ + "img/tun.50cd9101.svg";